/**
 * Zoho Chat widget visibility store
 */
import { createEvent, createStore } from 'effector';

type ZohoChatState = {
  visible: boolean;
};

const initialZohoChatState: ZohoChatState = {
  visible: false,
};

export const $zohoChat = createStore(initialZohoChatState);
export const showZohoChatEvent = createEvent();
export const hideZohoChatEvent = createEvent();

$zohoChat
  .on(showZohoChatEvent, (state) => ({ ...state, visible: true }))
  .on(hideZohoChatEvent, (state) => ({ ...state, visible: false }));

$zohoChat.watch((state) => {
  if (typeof window === 'undefined') return;

  const salesiq = window.$zoho?.salesiq;
  if (!salesiq) return;

  if (state.visible) {
    salesiq.chat.show?.();
    salesiq.floatbutton.visible?.('hide');
    salesiq.floatwindow.visible?.('show');
  } else {
    salesiq.chat.hide?.();
    salesiq.floatbutton.visible?.('hide');
    salesiq.floatwindow.visible?.('hide');
  }
});
